export default "__VITE_ASSET__2b8e9fd0__"